// import Error from 'components/alerts/Error'
import { Info } from 'components/common/form/modules/Info';

import { NumberInput } from 'components/common/form/modules/input/Number';
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import React, { useCallback, useState } from 'react'
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';

import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { updateSharedInventorybyAffiliate } from 'components/graphql/queries'
import PropTypes from 'prop-types';

// import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';

const ValueLabelComponent = (props) => {
    const { children, open, value } = props;
    return (
        <Tooltip open={open} enterTouchDelay={0} placement="right" title={value}>
            {children}
        </Tooltip>
    );
}

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
};

const AffiliatesModal: React.FC<{ [label: string]: any }> = (props: any) => {

    const [sharedInventory, setSharedInventory] = useState(props.sharedInventory)
    const [btnDisabled, setBtnDisabled] = React.useState(false)
    const [updateBtnText, setUpateBtnText] = React.useState('UPDATE')

    const updateCommission = useCallback(() => {

        let qtyErr = false
        let comErr = false

        sharedInventory.map((item: any, index: number) => {

            if (Number(item.quantity) < Number(item.minQuantity) || Number(item.quantity) > Number(item.maxQuantity)) {
                qtyErr = true
            }

            if (Number(item.commission) < Number(props.sharedInventory[index].commission) || Number(item.commission) > Number(item.maxCommission)) {
                comErr = true
            }

        })

        if (qtyErr) {
            alert('Quantity is invalid for one or more items')
            return;
        }

        if (comErr) {
            alert('Commission is invalid for one or more items')
            return;
        }

        setBtnDisabled(true)
        setUpateBtnText('UPDATING...')

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: updateSharedInventorybyAffiliate,
                variables: {
                    campaignId: props.campaignId,
                    userId: props.user.isAdmin ? props.createdBy : props.user.id,
                    username: props.username,
                    inventoryItems: sharedInventory.map((i: any) => {
                        return {
                            inventoryItemId: i.inventoryItemId,
                            quantity: Number(i.quantity),
                            commission: Number(i.commission) * 100,
                        }
                    })
                }
            })
            .then(res => {
                if (res.data.data.inventoryItem.updateSharedInventorybyAffiliate) {
                    props.reloadData()
                    closeModal()
                } else {
                    alert('An unknown error occurred, try again')
                    setBtnDisabled(false)
                    setUpateBtnText('UPDATE')
                }
            })
            .catch(err => {
                console.log(err)
                alert('An unknown error occurred, try again')
                setBtnDisabled(false)
                setUpateBtnText('UPDATE')
            })
        closeModal()
    }, [sharedInventory, props.sharedInventory, props.username, props.campaignId])

    const handleInventoryChange = useCallback((index, type, value) => {

        if (Number.isNaN(Number(value))) {
            return;
        }

        const temp = JSON.parse(JSON.stringify(sharedInventory))

        if (type === 'quantity') {
            temp[index].quantity = Number(value);
        } else if (type === 'commission') {
            temp[index].commission = Number(value);
        }
        setSharedInventory(temp)

    }, [sharedInventory, setSharedInventory])

    // const valuetext = (value) => {
    //     return `$${value}`;
    // }

    return <div>
        <div style={{
            overflowX: "scroll",
            paddingTop: '10px'
        }}>
            {
                sharedInventory.length > 0 ?
                    <table className='table-responsive--base m-0' style={{ width: '100%', textAlign: 'left', fontSize: '12px', paddingTop: '0px', marginTop: '5px' }}>
                        <thead>
                            <tr>
                                <td>TICKET</td>
                                <td>QTY</td>
                                {
                                    props.username.includes("-additional-link-") ? null : <td>COMMISSION</td>
                                }
                                <td>SALES</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                sharedInventory.map((item: any, index: any) => {
                                    return <tr key={index} style={{ alignContent: 'center', height: 'auto', padding: '10px' }}>
                                        <td>
                                            {item.inventoryItemName}
                                        </td>
                                        <td>
                                            <NumberInput
                                                value={item.quantity}
                                                min={item.minQuantity}
                                                max={item.maxQuantity}
                                                onChange={(e) => handleInventoryChange(index, 'quantity', e.target.value)}
                                                infoMessage={item.minQuantity + ' - ' + item.maxQuantity}
                                            />
                                        </td>
                                        {
                                            props.username.includes("-additional-link-") ? null : <td>
                                                <NumberInput
                                                    value={item.commission}
                                                    min={props.sharedInventory[index].commission}
                                                    max={item.maxCommission}
                                                    onChange={e => handleInventoryChange(index, 'commission', e.target.value)}
                                                    required={true}
                                                />
                                                <Info>
                                                    Affiliate earns  ${item.commission.toFixed(2)} <br />
                                                    You earn  ${
                                                        props.createdBy === props.user.id || props.user.isAdmin ?
                                                            (item.inventoryItemPrice - item.commission).toFixed(2)
                                                            : (item.maxCommission - item.commission).toFixed(2)
                                                    }<br />
                                                    (Minimum. ${props.sharedInventory[index].commission})
                                                </Info>
                                                {/* <Slider
                                                    value={item.commission}
                                                    onChange={(d, e) => handleInventoryChange(index, 'commission', Number(e))}
                                                    min={props.sharedInventory[index].commission}
                                                    max={item.maxCommission}
                                                    valueLabelDisplay="auto"
                                                    aria-labelledby="continuous-slider"
                                                    valueLabelFormat={valuetext}
                                                    style={{ fontSize: '8px' }}
                                                    ValueLabelComponent={ValueLabelComponent}
                                                /> */}
                                            </td>
                                        }
                                        <td>
                                            {item.minQuantity}
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                    :
                    <p style={{ width: '100%', textAlign: 'center' }}>
                        Inventory item not shared with affiliates
                    </p>
            }
        </div>
        {/* {
            error ?
                <div style={{ padding: '20px' }}>
                    <Error content={errorMessage} />
                </div>
                : null
        } */}
        {
            sharedInventory.length > 0 ?
                <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                    <button
                        disabled={btnDisabled}
                        role="submit"
                        type="submit"
                        className="new-button-save"
                        onClick={e => updateCommission()}
                    >
                        {updateBtnText}
                    </button>
                </div> : null
        }
        {/* <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
            <button className='new-button-cancel' onClick={() => closeModal()}>
                CANCEL
            </button>
        </div> */}
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(AffiliatesModal);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/AffiliatesModal.tsx